import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link';

import { photosShow } from '../../../helpers/photosShow';
import { banneruploadDir } from '../../../config';

import searchIcon from '/public/SiteIcons/bookYourIcon.svg';
import steeingIcon from '/public/SiteIcons/becomeaHostIcon.svg';

import cs from '../../commonStyle.css';
import s from './NewsBox.css';
import { dynamicImageBannerValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';
import { useIntl } from 'react-intl';

const NewsBox = ({ data }) => {

  const { locale } = useIntl();

  const { buttonLabel, buttonLabel2, title } = dynamicImageBannerValue(data, locale);

  const path = photosShow(banneruploadDir);

  return (
    <div>
      <h3 className={s.containerTitle}>{title}</h3>
      <div className={s.bgImage} style={{ backgroundImage: `url(${path}${data?.image})` }} />
      <div className={cx(s.buttonFlex, cs.paddingTop4)}>
        <Link to={data?.buttonLink1} className={cx(cs.btn, cs.btnPrimary, s.buttonFlex, 'hidden-xs')}>
          <img src={searchIcon} className={'imgIconRight'} />
          <span className={cs.vtrMiddle}>{buttonLabel || ''}</span>
        </Link>
        <Link to={data?.buttonLink2} className={cx(cs.btn, cs.btnPrimary, s.buttonFlex, s.marginLeft, 'marginLeftBoxRTL')}>
          <img src={steeingIcon} className={'imgIconRight'} />
          <span className={cs.vtrMiddle}>{buttonLabel2}</span>
        </Link>
      </div>
    </div>
  );
};

NewsBox.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonLabel2: PropTypes.string,
    buttonLink1: PropTypes.string,
    buttonLink2: PropTypes.string,
    image: PropTypes.string,
  }),
};

export default withStyles(cs, s)(NewsBox);
